module.exports = __webpack_public_path__ + "img/145.f1afae34.jpg";